import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { DocumentFormValues } from '@/forms/DocumentForm'
import { cn } from '@/lib/utils'
import { Currency } from '@/types/Currency'

import { DocumentArrayFields } from './DocumentArrayFields'
import { itemGridClass, itemGridMinWidth } from './gridTemplate'

const ColumnHeader = ({ children, className, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('text-[11px] font-medium uppercase tracking-[0.04em] text-muted-foreground', className)}
      {...rest}
    >
      {children}
    </div>
  )
}

export const DocumentItemsForm = ({
  currencies,
  isVatPayer,
}: {
  currencies?: Currency[]
  isVatPayer: boolean
}) => {
  const { control } = useFormContext<DocumentFormValues>()
  const currencyCode = useWatch({ control, name: 'settings.currency' })
  const currencySymbol = useMemo(
    () => currencies?.find((c) => c.code === currencyCode)?.symbol ?? 'Kč',
    [currencies, currencyCode],
  )

  return (
    <div className="-mr-1 -ml-6 overflow-x-auto pr-1 pb-1 pl-6">
      <div className={cn('relative grid w-full gap-1', itemGridMinWidth(isVatPayer))}>
        <div className={cn(itemGridClass(isVatPayer), 'border-b pb-2')}>
          <ColumnHeader className="pl-3">Položka</ColumnHeader>
          <ColumnHeader className="pr-2 text-right">Množství</ColumnHeader>
          <ColumnHeader className="pl-2">MJ</ColumnHeader>
          <ColumnHeader className="pr-8 text-right">Cena</ColumnHeader>
          {isVatPayer && <ColumnHeader className="pl-2.5">DPH</ColumnHeader>}
          <ColumnHeader className="text-right">Celkem</ColumnHeader>
          <ColumnHeader></ColumnHeader>
        </div>

        <DocumentArrayFields
          control={control}
          currencySymbol={currencySymbol}
          currencyCode={currencyCode || 'CZK'}
          isVatPayer={isVatPayer}
        />
      </div>
    </div>
  )
}
